import HtmlNode from '../Extension/HtmlNode';
import InputError from './InputError';
import InputInformation from './InputInformation';

interface InputFieldProps {
  readonly title: string;
  readonly value: string;
  readonly name: string;
  readonly id: string;
  readonly unit?: string;
  error?: boolean;
  errorMessage?: string;
  readonly placeholder?: string;
  readonly information?: string;
  readonly type?: string;
  readonly autocomplete?: string;
  readonly pattern?: string;
  readonly inputmode?: string;
  readonly onChange?: (e: Event) => void;
  readonly onBlur?: (e: Event) => void;
  readonly onKeyDown?: (e: KeyboardEvent) => void;
}

class InputFieldRegistrationNumber extends HtmlNode {
  private readonly props: InputFieldProps;
  private contexts: {
    error?: InputError;
  } = {};

  constructor(element: HTMLElement | null, props: InputFieldProps) {
    super(element);

    this.props = props;
    this.render();
  }

  private updateBorder() {
    const border = this.node.querySelector('.waykevaluation-input-text');
    if (border) {
      if (this.props.error) {
        border?.classList.add('waykevaluation-input-text--has-error');
      } else {
        border?.classList.remove('waykevaluation-input-text--has-error');
      }
    }
  }

  setError(error: boolean, errorMessage?: string) {
    this.props.error = error;
    if (errorMessage) {
      this.props.errorMessage = errorMessage;
    }
    this.updateBorder();
    this.contexts.error?.setError(error);
  }

  private render() {
    const {
      id,
      title,
      type,
      name,
      value,
      autocomplete,
      placeholder,
      unit,
      error,
      errorMessage,
      information,
      pattern,
      inputmode,
      onChange,
      onBlur,
      onKeyDown,
    } = this.props;

    this.node.innerHTML = `
      <div class="waykevaluation-input-label">
        <label for="${id}" class="waykevaluation-input-label__label waykevaluation-input-label__label--current-color">${title}</label>
      </div>
      <div class="waykevaluation-input-text">
        <div class="waykevaluation-input-text__prefix waykevaluation-input-text__prefix--illustration">
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 34" aria-hidden="true" style="height: 32px; display: block;">
            <rect width="22" height="34" rx="1" fill="#458BDD"></rect>
            <circle cx="11" cy="10" r="5.5" stroke="#FFF500" strokelinejoin="round" strokedasharray="1 2"></circle>
            <path d="M10.6707 21.692c1.392 0 2.04.564 2.28.996h1.644c-.264-1.08-1.248-2.364-3.924-2.364-2.028 0-3.408.912-3.408 2.436 0 1.536 1.2 2.34 2.904 2.508l1.512.156c.876.108 1.476.372 1.476 1.188 0 .684-.684 1.176-1.98 1.176-1.56 0-2.244-.72-2.472-1.26h-1.716c.336 1.224 1.404 2.628 4.188 2.628 2.412 0 3.624-1.116 3.624-2.652 0-1.8-1.308-2.448-3.012-2.616-.576-.06-.972-.108-1.5-.156-.888-.108-1.392-.444-1.392-1.02 0-.624.612-1.02 1.776-1.02Z" fill="#fff"></path>
          </svg>
        </div>
        <input
          ${type ? `type="${type}"` : 'type="text"'}
          ${type === 'number' ? `pattern="[0-9]*" inputmode="numeric"` : ''}
          id="${id}"
          ${pattern ? `pattern="${pattern}"` : ''}
          ${inputmode ? `inputmode="${inputmode}"` : ''}
          value="${value}"
          name="${name}"
          ${autocomplete ? `autocomplete="${autocomplete}"` : ''}
          ${placeholder ? `placeholder="${placeholder}"` : ''}
          class="waykevaluation-input-text__input"
        />
        ${unit ? `<div class="waykevaluation-input-text__unit">${unit}</div>` : ''}
      </div>
    `;

    this.updateBorder();
    if (errorMessage) {
      this.contexts.error = new InputError(this.node, {
        error,
        errorMessage,
      });
    }

    if (information) {
      new InputInformation(this.node.querySelector<HTMLElement>('.waykevaluation-input-label'), {
        information,
      });
    }

    const input = this.node.querySelector('input');
    if (input) {
      if (onChange) {
        input.addEventListener('input', onChange);
      }
      if (onBlur) {
        input.addEventListener('blur', onBlur);
      }

      if (onKeyDown) {
        input.addEventListener('keydown', onKeyDown);
      }
    }
  }
}

export default InputFieldRegistrationNumber;
